import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AddonApiService, AddonActivation, PartnerAddonInterface } from '@vendasta/partner';

export interface ListResponse {
  activations: AddonActivation[];
  hasMore: boolean;
  cursor: string;
}

@Injectable({ providedIn: 'root' })
export class AddonService {
  constructor(private _api: AddonApiService) {}

  list(partnerId: string, cursor?: string, pageSize?: number): Observable<ListResponse> {
    return this._api
      .listActivations({
        partnerId: partnerId,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize,
        },
      })
      .pipe(
        map((response) => {
          return {
            activations: response.activations,
            hasMore: response.pagingMetadata.hasMore,
            cursor: response.pagingMetadata.nextCursor,
          };
        }),
      );
  }

  activate(partnerId: string, addonId: string, quantity = 1): Observable<boolean> {
    return this._api
      .activate({
        partnerId: partnerId,
        addonId: addonId,
        quantity: quantity,
      })
      .pipe(map(() => true));
  }

  deactivate(partnerId: string, addonId: string, activationId: string): Observable<boolean> {
    return this._api
      .deactivate({
        partnerId: partnerId,
        addonId: addonId,
        activationId: activationId,
      })
      .pipe(map(() => true));
  }

  getActivation(partnerId: string, addonId: string, activationId: string): Observable<AddonActivation> {
    return this._api
      .getActivation({
        partnerId: partnerId,
        addonId: addonId,
        activationId: activationId,
      })
      .pipe(map((r) => r.activation));
  }

  listAddons(): Observable<PartnerAddonInterface[]> {
    return this._api.listPartnerAddons({}).pipe(map((resp) => resp?.addons));
  }
}
